(function() {
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[add-to-cart]');
    if (!btn) return;

    var id = parseInt(btn.getAttribute('add-to-cart'), 10);
    if (!id) return;

    var scope = btn.closest('[product-scope]') || document;

    /* Shopify B2B rejects any /cart/add.js payload that includes `selling_plan` with a
       422 "Only one-time purchase is available for B2B orders". The theme force-checks
       the Subscribe & Save radio on page load, so without this guard the plan ID would
       ride along on every add and nothing would ever land in a B2B customer's cart.
       window.__isB2BCustomer is set from theme.liquid via customer.tags. */
    var isB2B = window.__isB2BCustomer === true;

    var qtyInput = scope.querySelector('[product-watcher="quantity"]');
    var quantity = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;

    var sellingPlanId = null;
    if (!isB2B) {
      var subRadio = scope.querySelector('input[name="purchase_option"][value="selling_plan"]');
      var oneRadio = scope.querySelector('input[name="purchase_option"][value="onetime"]');
      if (!(oneRadio && oneRadio.checked) && (!subRadio || subRadio.checked)) {
        var planSelect = scope.querySelector('select[name="selling_plan_id"]');
        if (planSelect && planSelect.value) sellingPlanId = parseInt(planSelect.value, 10) || null;
      }
    }

    e.preventDefault();
    e.stopImmediatePropagation();

    var item = { id: id, quantity: quantity };
    if (sellingPlanId) item.selling_plan = sellingPlanId;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [item] })
    }).then(function(r) {
      if (!r.ok) return r.text().then(function(t) { throw new Error(r.status + ': ' + t); });
      return r.json();
    }).then(function() {
      document.dispatchEvent(new CustomEvent('pact:cart:refresh'));
      document.dispatchEvent(new CustomEvent('shapes:modalcart:afteradditem'));
    }).catch(function(err) {
      console.error('[Cart] Add failed:', err);
    });
  }, true);
})();

(function() {
  // Variant IDs capped at quantity 1
  var CAPPED_VARIANT_IDS = [48285937205481]; // Sampler Pack (CA)

  var enforcing = false;

  function enforceCaps() {
    if (enforcing) return;
    enforcing = true;
    fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
      var fixes = cart.items.filter(function(item) {
        return CAPPED_VARIANT_IDS.indexOf(item.variant_id) !== -1 && item.quantity > 1;
      });
      if (fixes.length === 0) { enforcing = false; return; }

      var updates = {};
      fixes.forEach(function(item) { updates[item.variant_id] = 1; });

      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates: updates })
      }).then(function() {
        document.dispatchEvent(new CustomEvent('pact:cart:refresh'));
      });
    }).catch(function(err) {
      console.error('[Cart cap] failed:', err);
    }).finally(function() {
      enforcing = false;
    });
  }

  document.addEventListener('pact:cart:refresh', enforceCaps);
})();